// extracted by mini-css-extract-plugin
module.exports = {"container":"Editor-module--container--3JXi2","readOnly":"Editor-module--read-only--1f-Lu"};